import React from 'react';
import { DashboardChartBox, HeaderTitle, HelpIcon } from '../styles';

interface Statistic {
  name: string;
  count: number;
}

interface TooltipInfo {
  statistic: string;
  text: string;
}

interface ParticipantStatisticsTableProps {
  statistics: Statistic[];
  tooltips: TooltipInfo[];
}

const ParticipantStatisticsTable: React.FC<ParticipantStatisticsTableProps> = ({
  statistics,
  tooltips,
}) => (
  <DashboardChartBox>
    <div
      style={{
        flex: 1,
        flexDirection: 'column',
        display: 'flex',
      }}
    >
      <HeaderTitle>
        <p>Overall Participant Statistics</p>
      </HeaderTitle>
      <div style={{ maxHeight: '400px', overflowY: 'visible' }}>
        <table className="styled-table">
          <thead>
            <tr>
              <th>Statistic</th>
              <th>Count</th>
            </tr>
          </thead>
          <tbody>
            {statistics.map((stat, index) => {
              const tip = tooltips.find(t => t.statistic === stat.name);
              return (
                <tr key={index}>
                  <td
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      gap: 8,
                    }}
                  >
                    {stat.name}
                    {tip && (
                      <HelpIcon>
                        ?<span className="tooltip">{tip.text}</span>
                      </HelpIcon>
                    )}
                  </td>
                  <td>{stat.count}</td>
                </tr>
              );
            })}
          </tbody>
        </table>
      </div>
    </div>
  </DashboardChartBox>
);

export default ParticipantStatisticsTable;
